import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import Transition from 'react-transition-group/Transition';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './tabs.scss';

const duration = 250;

class Tab extends PureComponent {
  render() {
    const className = cn('btn', 'btn-flex', {
      'solid-white': this.props.active,
      'solid-turq': !this.props.active
    });

    const { pathname } = this.props.tab;

    const link = this.props.active && !this.props.subnavigationPage
      ? `${pathname}subnavigation/`
      : pathname;

    return (
      <Link to={link} className={className}>
        <span>
          <em>
            {this.props.active ? 'Подробнее' : ''}
            <span className="icon">→</span>
          </em>
          {this.props.tab.button}
        </span>
      </Link>
    );
  }
}

Tab.propTypes = {
  active: PropTypes.bool.isRequired,
  tab: PropTypes.object.isRequired,
  subnavigationPage: PropTypes.bool
};

class Tabs extends PureComponent {
  constructor(...props) {
    super(...props);

    this.state = {
      activeIndex: this.props.activeIndex,
      animate: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.isMobile) {
      return;
    }

    const { activeIndex } = nextProps;

    if (this.state.activeIndex !== activeIndex) {
      this.setState({ animate: true });

      setTimeout(() => {
        this.setState({ activeIndex, animate: false });
      }, duration);
    }
  }

  render() {
    const activeIndex = (this.props.isMobile)
      ? this.state.activeIndex
      : this.props.activeIndex;

    return (
      <Transition in={this.state.animate} timeout={duration}>
        {status =>
          <div className={cn('tabs', { [status]: this.props.isMobile })}>
            {this.props.tabs.map((tab, index) =>
              <Tab
                key={index}
                active={activeIndex === index}
                tab={tab}
                subnavigationPage={this.props.subnavigationPage}
              />
            )}
          </div>
        }
      </Transition>
    );
  }
}

Tabs.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  subnavigationPage: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Layout/Subnavigation/Tabs.js